import { render } from "./com_ventas.vue?vue&type=template&id=0db88b63&scoped=true"
import script from "./com_ventas.vue?vue&type=script&lang=js"
export * from "./com_ventas.vue?vue&type=script&lang=js"

import "./com_ventas.vue?vue&type=style&index=0&id=0db88b63&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db88b63"]])

export default __exports__